import { api } from "./api";

const SESSION_KEY = "opus_session_id";

function getSessionId() {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

export function track(event_type, extra = {}) {
  const payload = {
    event_type,
    session_id: getSessionId(),
    path: window.location.pathname + window.location.search,
    referrer: document.referrer || "",
    ...extra,
  };
  // Fire-and-forget; do not block UX
  api.post("/analytics/track", payload).catch(() => {});
}
